'use strict';

angular.module('pulse')
    .filter('capitalize', ['$text', function($text) {
            return function(string) {
                return $text.capital(string);
            };
        }]);
